import { initMap, equalCols, getCookie } from '../functions';
//import Swal from 'sweetalert2'

$(document).ready(function() {

	const contactWidget = {
        isLoading: false,
        init() {
            $(document).on('click', '.submit-contact-form', this, this.send);
        },
		send(event) {
			const _this = event.data;
			event.preventDefault();

			let mid = $(this).data('mid');

			if (_this.isLoading) {
                return false;
            }

			$('.contact-form-msgs-holder').hide();
            $('#contact-form').find('.form-control').removeClass('is-invalid');
            $('#contact-form').find('.form-check-input').removeClass('is-invalid');

			//Loading...
            _this.isLoading = true;
			let element = this;
			$(element).find('i').show();

			var values='';
            values+='module_id=' + mid;
            values+='&type=' + $(element).data('type');
            if($(element).data('type') == 1) {
                values+='&company=' + $('#contact_company_' + mid).val();
            }
            values+='&name=' + $('#contact_name_' + mid).val();
            values+='&last_name=' + $('#contact_last_name_' + mid).val();
            values+='&email=' + $('#contact_email_' + mid).val();
            values+='&phone=' + $('#contact_phone_' + mid).val();
            values+='&message=' + $('#contact_message_' + mid).val();
            // values+='&g-recaptcha-response=' + grecaptcha.getResponse();
            //values+='&terms-and-condition=' + ($('#contact_terms-and-condition_' + mid).is(":checked")?1:'');
            values+='&privacy=' + ($('#contact_privacy_' + mid).is(":checked")?1:'');
            if($('.contact_services').length > 0) {
                var contactServices = $('.contact_services:checked').map(function(){
                    return $(this).val();
                }).get();
                values+='&services=' + contactServices.join(',');
            }
            values+='&_token=' + $("meta[name='csrf-token']").attr("content");
			$.ajax({
	            type: "POST",
	            url: baseURL + '/contact/send',
	            data: values,
	            success: function(response) {
					_this.isLoading = false;
					$(element).find('i').hide();
                    // grecaptcha.reset();

					if (response.status == 0) {
						var errorHtml = '';
                        for(var errorKey in response.errors) {
                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                $('#contact_' + errorKey + '_' + mid).addClass('is-invalid');
                                errorHtml += response.errors[errorKey][error] + '<br>';
                            }
                            //$("#"+errorKey).closest('.form-group').addClass('has-error');
                            //$("#"+errorKey).css('border', '1px solid red');
                        }
                        //errorHtml
                        errorHtml;
                        $('#contact-form-error-msg').html(errorHtml);
                        $('#contact-form-error-msg').fadeIn();
                        //$('#contact-form-error-msg').delay(10000).fadeOut();
                        //errors
                        return false;
                    }

					if (response.status == 1) {
						$('#contact_name_' + mid).val('');
						$('#contact_company_' + mid).val('');
						$('#contact_last_name_' + mid).val('');
                        $('#contact_email_' + mid).val('');
                        $('#contact_phone_' + mid).val('');
                        $('#contact_message_' + mid).val('');
						$('#contact_privacy_' + mid).prop('checked', false);
						$('.contact_services').prop('checked', false);
						//$('#contact_terms-and-condition_' + mid).prop('checked', false);

						Swal.fire({
							// icon: 'success',
							// title: 'Success!',
							html: response.message
						});

						if (cookies_advertisement == 1) {
							//gtag('event', 'conversion', {'send_to': ''});
						}

						if (cookies_advertisement == 1 || cookies_social == 1) {
							//fbq('track', 'Lead');
						}

						return false;
					}

					if (response.status == 2) {
						$('#contact-form-error-msg').html(response.errors);
                        $('#contact-form-error-msg').fadeIn();
                        //$('#contact-form-error-msg').delay(10000).fadeOut();
                    }

					if (response.status == 3) {
						$('#contact-form-error-msg').html(response.errors);
                        $('#contact-form-error-msg').fadeIn();
                        //$('#contact-form-error-msg').delay(10000).fadeOut();
                    }
	            },
                error(error) {
                    // grecaptcha.reset();
                    _this.isLoading = false;
					$(element).find('i').hide();
                },
	        });
		}
    };

    if ($('.form-contact-home').length) {
        contactWidget.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/contact.js